/**
 * The TPV without a connection (docs/decisions/2026-10-28-tpv-sin-conexion.md,
 * docs/decisions/2026-10-31-tpv-offline-without-a-caja-tablet.md): every duration, count and size the detection and the
 * offline mode use, by name. Durations are measured on the
 * monotonic clock (`performance.now()`), never on the wall clock.
 */

/** Sustained loss before the offline mode («about one minute»). */
export const TPV_OFFLINE_AFTER_MS = 60_000;
/** Probes that must have failed in that minute. */
export const TPV_OFFLINE_MIN_FAILED_PROBES = 4;
/** When «Pasar ya a modo sin conexión» appears. */
export const TPV_MANUAL_OFFLINE_AFTER_MS = 15_000;
/** Consecutive reachable probes that end «Reconectando…» (and the read-only state). */
export const TPV_RECONNECTED_SUCCESSES = 2;
/** Consecutive reachable probes that prove a return stable. */
export const TPV_RETURN_STABLE_SUCCESSES = 3;
/** The span those probes must cover. */
export const TPV_RETURN_STABLE_MS = 20_000;
/** The probe while online and visible. */
export const TPV_PROBE_INTERVAL_ONLINE_MS = 15_000;
/** The probe while reconnecting and returning. */
export const TPV_PROBE_INTERVAL_FAST_MS = 5_000;
/** The probe while offline and read-only. */
export const TPV_PROBE_INTERVAL_OFFLINE_MS = 10_000;
/** The probe's deadline, with a session or without (the client's default is 15 s). */
export const TPV_PROBE_TIMEOUT_MS = 6_000;
/** The boot door asks the public clock again after this long before it calls the Service unreachable. */
export const TPV_BOOT_CLOCK_RETRY_MS = 5_000;
/** Consecutive transport failures while syncing that go back offline. */
export const TPV_SYNC_FAILURES_TO_OFFLINE = 3;
/** A clock sample whose round trip took longer is discarded. */
export const TPV_CLOCK_MAX_RTT_MS = 2_000;
/** Throttle of the kit's snapshot write. */
export const TPV_KIT_SNAPSHOT_MIN_INTERVAL_MS = 30_000;
/** Photo renditions answers the kit keeps, the oldest dropped first (the service worker keeps 400 photo files). */
export const TPV_KIT_MEDIA_MAX = 300;
/** Segment retries while syncing (the last delay repeats). */
export const TPV_SYNC_RETRY_DELAYS_MS: readonly number[] = Object.freeze([2_000, 4_000, 8_000, 16_000, 30_000]);
/** «Anular pedido» offline: the last offline round, within its first ten minutes. */
export const TPV_ENTRY_VOID_WINDOW_MS = 600_000;
/** Uploaded entries stay 48 h on the device, for reprints; so do the ones a manager took off, their only full copy. */
export const TPV_ACKNOWLEDGED_RETENTION_MS = 172_800_000;
/** A table with more entries is cut into several segments. */
export const TPV_SEGMENT_MAX_ENTRIES = 200;
/** A segment's body stays below the API's 300 kB limit. */
export const TPV_SEGMENT_MAX_BYTES = 250_000;
/** Above 3.000 € a complete invoice needs the client's data: the charge warns before the tap. */
export const TPV_SIMPLIFIED_INVOICE_MAX_MINOR = 300_000;
